import { FormattedMessage } from "react-intl";

import {
    SignupBackgroundLayout,
    TwcOverlayTemplate
} from "@/components/signup/layouts";
import SiteActivation, {
    ExistingUser,
    ReturnToProduct
} from "@/components/signup/site-activation";
import { TeamworkCollectionLogo } from "@/components/signup/utils";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import { SubHeading, WelcomeBackHeading } from "../../components";

export const CurrentProductUser = () => {
    const twcSignupOverlayEnrolled = checkFeatureFlagGate(
        featureFlags.cfind5480TwcSignupOverlay
    );

    let content = (
        <SignupBackgroundLayout ProductLogo={<TeamworkCollectionLogo />}>
            <WelcomeBackHeading />
            <SubHeading>
                <FormattedMessage
                    id="return-to-product-modal.header.text"
                    defaultMessage="Pick up where you left off."
                />
            </SubHeading>
            {/* everyone with a teamwork collection should see a return to product experience */}
            <SiteActivation
                CurrentProductUser={
                    <ReturnToProduct
                        ExistingUser={<ExistingUser SitePicker={null} />}
                    />
                }
            />
        </SignupBackgroundLayout>
    );

    if (twcSignupOverlayEnrolled) {
        content = (
            <TwcOverlayTemplate size="sm">
                <WelcomeBackHeading />
                <SubHeading>
                    <FormattedMessage
                        id="return-to-product-modal.header.text"
                        defaultMessage="Pick up where you left off."
                    />
                </SubHeading>
                {/* everyone with a teamwork collection should see a return to product experience */}
                <SiteActivation
                    CurrentProductUser={
                        <ReturnToProduct
                            ExistingUser={<ExistingUser SitePicker={null} />}
                        />
                    }
                />
            </TwcOverlayTemplate>
        );
    }

    return content;
};
